import urls from "../../api/urls.json";
import Loader from "../Loader";
import { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";
import ImageWrapper from "../ImageWrapper";
import {GapView, FlexWrapper, FlexWrapperCenterForProfile} from "../../styles/WrapperStyles";
import ProfileTextViewContainer from "../ProfileTextViewContainer";
import { convert_inches, getProfileDOB } from "../../utils";
import PhoneCodeModal from "../modals/PhoneCodeModal";
import GenderModal from "../modals/GenderModal";
import CropImage from "../CropImage";
import { authorizedHttpGet, authorizedHttpPost } from "../../api/httpCalls";
import '../styles/FeedDetailedProfileView.css';
import {profileEditPermission} from "../../access_levels";
import MessageModal from "../modals/MessageModal";
import DeleteProfileModal from "../modals/DeleteProfileModal";
import FilterModal from "../modals/FilterModal";
import WaveformAudioPlayer from "../../WaveformAudioPlayer";
import { uploadCroppedImageToS3 } from "../../api/imageUpload";

const ParentDiv = styled.div`
    margin: 80px 0 0 200px;
    display: flex;
`;

const InputTextAbout = styled.textarea`
  margin-right: 20%;
  border-radius: 13px;
  border: solid 1px #d7d7d7;
  font-family: 'Gilory-Semi';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
  padding: 20px;
  outline: none;
  width: 1040px;
`;

const BottomButton = styled.button`
cursor: pointer;
    width: 175px;
    height: 66px;    
    border-radius: 33px;
    box-shadow: 0 2px 4px 0 rgba(198, 194, 194, 0.5);
    border: solid 1px #d7d7d7;
    font-family: 'Gilory-Bold';
    font-size: 20px;
    font-weight: 800;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    margin:0;
    ${props => props.buttonLike && css`
        color: ${props => props.selected ? "#FFFFFF" : "#4ca851"};
        background-color: ${props => props.selected ? "#4ca851" : "#FFFFFF"};
        border: ${props => props.selected ? "none" : "solid 1px #d7d7d7"};
    `}
    ${props => props.buttonPass && css`
        color: ${props => props.selected ? "#FFFFFF" : "#ec4655"}
        background-color: ${props => props.selected ? "#ec4655" : "#FFFFFF"}
        border: ${props => props.selected ? "none" : "solid 1px #d7d7d7"}
    `}
    ${props => props.buttonInapp && css`
        color: ${props => props.selected ? "#FFFFFF" : "#464646"};
        background-color: ${props => props.selected ? "#464646" : "#FFFFFF"};
        border: ${props => props.selected ? "none" : "solid 1px #d7d7d7"};
    `}
    ${props => props.marginRight && css`
        margin-right: 25px;
    `}
`;
styled(BottomButton)`
  width: 100px;
  margin-left  :30px;
`;
const FlexInfoParent = styled(FlexWrapper)`
  flex-flow: wrap;
  gap: 16px;
`;

const IcebreakerSection = styled.div`
  margin-top: 15px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
`;

const IcebreakerTitle = styled.h3`
  font-family: 'Gilory-Bold';
  font-size: 18px;
  color: #464646;
  margin-bottom: 10px;
`;

const IcebreakerQuestion = styled.div`
  font-family: 'Gilory-Semi';
  font-size: 14px;
  color: #d32f2f;
  margin-bottom: 6px;
  font-weight: 500;
`;

const IcebreakerAnswer = styled.div`
  font-family: 'Gilory-Semi';
  font-size: 16px;
  color: #1976d2;
  font-weight: 600;
`;

const IcebreakerAnswerInput = styled.textarea`
  width: 100%;
  min-height: 72px;
  border-radius: 13px;
  border: solid 1px #d7d7d7;
  font-family: 'Gilory-Semi';
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  padding: 14px 16px;
  outline: none;
  resize: vertical;
  box-sizing: border-box;
  background-color: #ffffff;
`;


const FeedDetailedProfileView = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [profile, setProfile] = useState({});
    const [icebreakers, setIcebreakers] = useState([]);
    const [togglePhoneCodeModal, setTogglePhoneCodeModal] = useState(false);
    const constantList = useRef({})
    const [phoneCode, setPhoneCode] = useState(null);
    const [phobeCodeId, setPhoneCodeId] = useState(null);
    const [email, setEmail] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [DOB, setDOB] = useState(null);
    const [toggleGenderModal, setToggleGenderModal] = useState(false);
    const [gender, setGender] = useState(null);
    const [profileAbout, setProfileAbout] = useState(null);
    const [images, setImages] = useState([]);
    const [decoy, setDecoy] = useState(false);
    const accessLevel = localStorage.getItem('accessLevel');
    const [showCropImage, setShowCropImage] = useState(false);
    const [cropPhoto, setCropPhoto] = useState('');
    const [isSuspicious, setIsSuspicious] = useState(false);
    const [showDeleteButton, setShowDeleteButton] = useState(false);
    const [displayMessageModal, setDisplayMessageModal] = useState(false);
    const [displayMessage, setDisplayMessage] = useState('Profile cannot be deleted');
    const [modalText, setModalText] = useState('Are you sure you want to delete?');
    const [deleteProfileSubModal, setDeleteProfileSubModal] = useState(false);
    const [banFilterModal, setBannedFilterModal] = useState(false);
    const appName = localStorage.getItem('appName');
    const maxIcebreakersToShow = appName === 'Aisle' ? 1 : 3;
    const hideModerationActions = props.hideModerationActions === true;


    const itemClicked = (type) => {
        if (type === 'Phone Codes') {
            setTogglePhoneCodeModal(true);
        } else if (type === 'Gender') {
            setToggleGenderModal(true);
        }
    }

    const setInputItem = (type, value) => {
        if (type === 'Email') {
            setEmail(value);
            setProfile({ ...profile, personal_email: value });
        } else if (type === 'First Name') {
            setFirstName(value);
            setProfile({ ...profile, first_name: value });
        } else if (type === 'Phone Number') {
            setPhoneNumber(value);
            setProfile({ ...profile, fetch_only_number: value });
        } else if (type === 'DOB') {
            setDOB(getProfileDOB(value));
            setProfile({ ...profile, date_of_birth: value });
        }
    }

    const itemSelected = (code, id) => {
        setPhoneCode(code);
        setPhoneCodeId(id);
        setTogglePhoneCodeModal(false);
        setProfile({ ...profile, phone_code: code, phone_code_id: id });
    }


    const getProfileDetails = async () => {
        setIsLoading(true)
        let response = await authorizedHttpGet(`${urls.GET_PROFILE}/${localStorage.getItem('detailViewRef')}`, { "ref": localStorage.getItem('detailViewRef') });
        if (response.status) {
            setProfile(response.data.user);
            setPhoneCode(response.data.user.phone_code);
            setEmail(response.data.user.personal_email);
            constantList.current = response.data.constant_list;
            setFirstName(response.data.user.first_name);
            setShowDeleteButton(response.data.user.show_delete_button)
            setPhoneNumber(response.data.user.fetch_only_number);
            setDOB(getProfileDOB(response.data.user.date_of_birth));
            setGender(response.data.user.gender)
            setProfileAbout(response.data.user.about)
            setImages(response.data.user.photos)
            setPhoneCodeId(response.data.user.phone_code_id)
            setIcebreakers((response.data.user.icebreakers || []).slice(0, maxIcebreakersToShow))
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getProfileDetails();
    }, []);

    const approveProfile = async () => {
        setIsLoading(true);
        await authorizedHttpPost(urls.APPROVE_AND_EDIT, profile)
        setIsLoading(false);
        props.closeDetailedView();
        props.afterSave();
    }
    const handleButtonEvents = async (buttonEvent, otpId) => {
        setDeleteProfileSubModal(false)
        setIsLoading(true)
        let response = await authorizedHttpPost(urls.DELETE_PROFILE, { ref: profile.ref, otp: otpId })
        if (response.data.status) {
            props.closeDetailedView();
            props.afterSave();
        } else {
            setDisplayMessage(response.data.message);
            console.log("response message", response.data.message);
            setDisplayMessageModal(true)
        }
        setIsLoading(false)
    }

    const updateProfile = async () => {
        setIsLoading(true);
        await authorizedHttpPost(urls.UPDATE_PROFILE, profile)
        setIsLoading(false);
        props.closeDetailedView();
        props.afterSave();
    }

    const disapproveProfile = async () => {
        setIsLoading(true);
        await authorizedHttpPost(urls.DISAPPROVE, { ref: profile.ref, isSuspicious: isSuspicious })
        setIsLoading(false);
        props.closeDetailedView();
        props.afterSave();
    }

    const inappProfile = async () => {
        setIsLoading(true);
        await authorizedHttpPost(urls.INAPPROPRIATE_PROFILE, { ref: profile.ref })
        setIsLoading(false);
        props.closeDetailedView();
        props.afterSave();
    }

    const onBanClicked = async () => {
        setBannedFilterModal(true)
    }
    const banProfile = async (buttonEvent, otpId) => {
        setBannedFilterModal(false)
        setIsLoading(true);
        await authorizedHttpPost(urls.BAN_PROFILE, { ref: profile.ref , reason: otpId })
        setIsLoading(false);
        props.closeDetailedView();
        props.afterSave();
    }


    const addImage = (path) => {
        setImages([...images, { photo: path }]);
        profile.photos = [...images, { photo: path }];
    }

    const setSelectedImage = (photo_id) => {
        profile.photos.map((obj) => {
            if (obj.photo_id === photo_id) {
                obj.selected = true;
            } else {
                obj.selected = false;
            }
        });
        setImages(profile.photos);
        setDecoy(!decoy);
    }

    const deleteImage = (photoIndex) => {
        images.splice(photoIndex, 1);
        setImages(images);
        setDecoy(!decoy);
    }

    const onDeleteProfileClicked = () => {
        updateModalText('Are you sure you want to delete?')
        setDeleteProfileSubModal(true)
    }

    const closeModal = () => {
        setShowCropImage(false);
    }

    const updateModalText = (text) => {
        setModalText(text)
    }
    const updateGender = (gen) => {
        setGender(gen);
        setToggleGenderModal(false);
        setProfile({ ...profile, gender: gen })
    }

    const updateProfileAbout = (about) => {
        setProfileAbout(about);
        profile.about = about;
    }

    const updateIcebreakerAnswer = (index, answer) => {
        const updatedIcebreakers = icebreakers.map((icebreaker, icebreakerIndex) => (
            icebreakerIndex === index ? { ...icebreaker, answer } : icebreaker
        ));
        setIcebreakers(updatedIcebreakers);
        setProfile({ ...profile, icebreakers: updatedIcebreakers });
    }

    const dragOverItem = useRef();
    const dragImageUrl = useRef();

    const dragStart = (e, position, url) => {
        dragImageUrl.current = url;
        dragOverItem.current = position;
    };

    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    const dropImage = () => {
        setDecoy(!decoy);
        images[dragOverItem.current] = { "photo": dragImageUrl.current };
        setImages(images);
        dragImageUrl.current = null;
        dragOverItem.current = null;
    }

    const showImageCrop = (photo) => {
        setCropPhoto(photo)
        setShowCropImage(true);
    }

    const saveCroppedImage = (photo) => {
        saveCroppedImageWithPresignedUrl(photo);
        return;
        images[localStorage.getItem('photoIndex')] = { "photo": photo };
        setImages(images);
        setShowCropImage(false);
    }

    const saveCroppedImageWithPresignedUrl = async (photo) => {
        const index = localStorage.getItem('photoIndex');
        const profileRef = profile?.ref || localStorage.getItem('detailViewRef');
        try {
            setIsLoading(true);
            const s3Url = await uploadCroppedImageToS3(photo, profileRef);
            images[index] = { "photo": s3Url };
            setImages(images);
            setShowCropImage(false);
        } catch (e) {
            console.error('Failed to save cropped image', e);
        } finally {
            setIsLoading(false);
        }
    }

    const handleSuspicious = () => {
        setIsSuspicious(!isSuspicious)
    }


    return (

        isLoading ? <Loader /> : (

            Object.keys(profile).length > 0 ? (
                <>
                    {showCropImage ? <CropImage photo={cropPhoto} closeModal={closeModal} saveCroppedImage={saveCroppedImage} /> : null}
                    {displayMessageModal ? <MessageModal closeModal={closeModal} message={displayMessage} /> : null}
                    {deleteProfileSubModal ? <DeleteProfileModal closeModal={() => setDeleteProfileSubModal(false)} handleButtonEvents={handleButtonEvents} modalText={modalText} /> : null}
                    {banFilterModal ? <FilterModal closeModal={() => setBannedFilterModal(false)} handleButtonEvents={banProfile} modalText={"Apply a Filter"} /> : null}
                    {togglePhoneCodeModal && <PhoneCodeModal closeModal={() => setTogglePhoneCodeModal(false)} list={constantList.current.phonecodes} itemSelected={itemSelected} />}
                    {toggleGenderModal && <GenderModal closeModal={() => setToggleGenderModal(false)} updateGender={updateGender} />}
                    <span className="sideNavCloseBtn" onClick={() => props.closeDetailedView()} >
                        &times;
                    </span>
                    <ParentDiv>
                        <GapView height="20px" />
                        {
                            [0, 1, 2, 3].map((photo, index) => (
                                <div
                                    onDragStart={(e) => dragStart(e, index, images[photo].photo)}
                                    onDragEnter={(e) => dragEnter(e, index)}
                                    onDragEnd={() => dropImage()}
                                    className="dragDropContainer"
                                >
                                    <ImageWrapper key={index} src={images[photo]} addImage={addImage} selectedImage={setSelectedImage} deleteImage={deleteImage} canDelete={images.length > 1} toggleCrop={showImageCrop} closeModal={closeModal} showImageCrop={showImageCrop} photoIndex={index} />
                                </div>
                            ))
                        }
                        <GapView height="20px" />
                    </ParentDiv>
                    <div className="profileDetailFeedDiv">
                        <InputTextAbout value={profileAbout} disabled={!profileEditPermission.includes(accessLevel)} onChange={(e) => updateProfileAbout(e.target.value)} />

                        {icebreakers.length > 0 && (
                            <IcebreakerSection>
                                <IcebreakerTitle>Ice Breakers</IcebreakerTitle>
                                {icebreakers.map((icebreaker, index) => (
                                    <div key={index} style={{ marginBottom: '8px' }}>
                                        <IcebreakerQuestion>{icebreaker.question}</IcebreakerQuestion>
                                        {profileEditPermission.includes(accessLevel) ? (
                                            <IcebreakerAnswerInput
                                                value={icebreaker.answer || ''}
                                                onChange={(e) => updateIcebreakerAnswer(index, e.target.value)}
                                            />
                                        ) : (
                                            <IcebreakerAnswer>{icebreaker.answer}</IcebreakerAnswer>
                                        )}
                                    </div>
                                ))}
                            </IcebreakerSection>
                        )}

                        <FlexInfoParent>
                            <ProfileTextViewContainer input={true} title={'First Name'} value={firstName} editable={profileEditPermission.includes(accessLevel)} setInputItem={setInputItem} />
                            <ProfileTextViewContainer input={true} title={'Email'} value={email} editable={profileEditPermission.includes(accessLevel)} setInputItem={setInputItem} />
                            <ProfileTextViewContainer title={'Phone Codes'} value={phoneCode} editable={profileEditPermission.includes(accessLevel)} itemClicked={itemClicked} />
                            <ProfileTextViewContainer input={true} title={'Phone Number'} value={phoneNumber} editable={profileEditPermission.includes(accessLevel)} setInputItem={setInputItem} />

                            <ProfileTextViewContainer type="date" value={DOB} input={true} title={'DOB'} editable={profileEditPermission.includes(accessLevel)} setInputItem={setInputItem} />
                            <ProfileTextViewContainer title={'City'} value={profile.city_of_residence ? profile.city_of_residence.name : null} editable={false} />
                            <ProfileTextViewContainer onClick={() => toggleGenderModal(true)} title={'Gender'} value={gender} editable={profileEditPermission.includes(accessLevel)} itemClicked={itemClicked} />
                            <ProfileTextViewContainer title={'Mother Tongue'} value={profile.mother_tongue ? profile.mother_tongue.name : null} editable={false} />

                            <ProfileTextViewContainer title={'Marital Status'} value={profile.marital_status_v1 ? profile.marital_status_v1.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Faith'} value={profile.faith ? profile.faith.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Smoking'} value={profile.smoking_v1 ? profile.smoking_v1.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Drinking'} value={profile.drinking_v1 ? profile.drinking_v1.name : null} editable={false} />

                            <ProfileTextViewContainer title={'Height'} value={convert_inches(profile.height)} editable={false} />
                            <ProfileTextViewContainer title={'Industry or Company'} value={profile.partial_work && profile.partial_work.industry ? profile.partial_work.industry : null} editable={false} />
                            <ProfileTextViewContainer title={'Work Title'} value={profile.partial_work && profile.partial_work.work_title ? profile.partial_work.work_title : null} editable={false} />
                            <ProfileTextViewContainer title={'College'} value={profile.partial_work && profile.partial_work.college ? profile.partial_work.college : null} editable={false} />

                            <ProfileTextViewContainer title={'Graduation Year'} value={profile.partial_work && profile.partial_work.graduation_year ? profile.partial_work.graduation_year : null} editable={false} />
                            <ProfileTextViewContainer title={'Sun Sign'} value={profile.sun_sign_v1 ? profile.sun_sign_v1.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Kids'} value={profile.kid ? profile.kid.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Diet'} value={profile.diet ? profile.diet.name : null} editable={false} />

                            <ProfileTextViewContainer title={'Pets'} value={profile.pet ? profile.pet.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Settle Down'} value={profile.settle ? profile.settle.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Highest Qualification'} value={profile.work && profile.work.highest_qualification_v1 ? profile.work.highest_qualification_v1.name : null} editable={false} />
                            <ProfileTextViewContainer title={'Income'} value={profile.work && profile.work.monthly_income_v1 ? profile.work.monthly_income_v1.name : null} editable={false} />
                            {profile.audio_url != null && (<WaveformAudioPlayer title={"Audio Prompt"} audioUrl={profile.audio_url}/>)}
                        </FlexInfoParent>
                        <GapView height="5px" />

                        {!profile.deleted &&
                            <input type="checkbox" checked={isSuspicious} onChange={handleSuspicious} style={{ width: "20px", height: "20px" }} />
                        }
                        {
                            <FlexWrapperCenterForProfile className="marginHorizontal30">
                                {
                                    !profile.deleted &&
                                    <>
                                        {profileEditPermission.includes(accessLevel) && showDeleteButton && (          //  ← extra condition
                                            <BottomButton
                                                buttonInapp
                                                selected={true}
                                                onClick={onDeleteProfileClicked}
                                            >
                                                Delete
                                            </BottomButton>
                                        )}
                                        {!hideModerationActions && (
                                            <BottomButton
                                                buttonLike
                                                selected={true}
                                                onClick={() => {
                                                    approveProfile();
                                                }}
                                            >
                                                Approve
                                            </BottomButton>
                                        )}
                                        <BottomButton
                                            buttonLike
                                            selected={true}
                                            onClick={() => {
                                                updateProfile()
                                            }}
                                        >
                                            Update
                                        </BottomButton>
                                        {!hideModerationActions && (
                                            <>
                                                <BottomButton
                                                    className="bottomButtonFeed"
                                                    buttonPass
                                                    selected={true}
                                                    onClick={() => {
                                                        disapproveProfile()
                                                    }}
                                                >
                                                    Disapprove
                                                </BottomButton>
                                                <BottomButton
                                                    buttonInapp
                                                    selected={true}
                                                    onClick={() => {
                                                        inappProfile()
                                                    }}
                                                >
                                                    Inappropriate
                                                </BottomButton>
                                            </>
                                        )}
                                    </>
                                }

                                <BottomButton
                                    buttonInapp
                                    selected={true}
                                    onClick={() => {
                                        onBanClicked()
                                    }}
                                >
                                    Ban
                                </BottomButton>
                            </FlexWrapperCenterForProfile>
                        }
                    </div >
                </>
            ) : null
        )
    )
}

export default FeedDetailedProfileView;
